export interface NoteData {
  dateTime: string;
  editPerson: string;
  desc: string;
  note: string;
  from?: string;
  to?: string;
}

export class NoteData implements NoteData {
  dateTime = '';
  editPerson = '';
  desc = '';
  note = '';
  constructor(){}
}
